module.exports = __webpack_public_path__ + "img/cert-failure.f0285630.svg";